export const checkedInUsersBySegmentKey = ({ bookingInfo, segmentKey }) => {
  let response: any = [];

  try {
    const { journeys } = bookingInfo;
    for (let index = 0; index < journeys.length; index += 1) {
      const segment = journeys[index]?.segments;
      for (let i = 0; i < segment.length; i += 1) {
        if (segment[i]?.segmentKey === segmentKey) {
          const passenger = segment[i].passengerSegment;
          for (let j = 0; j < passenger.length; j += 1) {
            if (passenger[j].liftStatus === "CheckedIn" || passenger[j].liftStatus === "Boarded") {
              const passengerData = bookingInfo.passengers.filter(
                (data) => data.passengerKey === passenger[j].passengerKey
              );
              const user = {
                name: `${passengerData[0]?.name.first.charAt(0).toUpperCase()}${passengerData[0]?.name.first.slice(
                  1
                )} ${passengerData[0]?.name.last.charAt(0).toUpperCase()}${passengerData[0]?.name.last.slice(1)}`,
                key: passenger[j].passengerKey,
                isInfant: false,
                segmentKey: segment[i].segmentKey
              };
              response.push(user);
              if (passengerData[0]?.infant != null) {
                const infant = {
                  name: `${passengerData[0]?.infant.name.first} ${passengerData[0]?.infant.name.last}`,
                  key: passenger[j].passengerKey,
                  isInfant: true,
                  segmentKey: segment[i].segmentKey
                };
                response.push(infant);
              }
            }
          }
        }
      }
    }
  } catch (error) {
    response = false;
    console.warn(error);
  }
  return response;
};
